import { render, staticRenderFns } from "./save-button.vue?vue&type=template&id=498d5f19&scoped=true"
import script from "./save-button.vue?vue&type=script&lang=js"
export * from "./save-button.vue?vue&type=script&lang=js"
import style0 from "./save-button.vue?vue&type=style&index=0&id=498d5f19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d5f19",
  null
  
)

export default component.exports